import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import TYPES from '../util/types';

export type MimeType =
    | 'Application/xml'
    | 'application/PowerShell'
    | 'application/atom+xml'
    | 'application/directx'
    | 'application/envoy'
    | 'application/etl'
    | 'application/fractals'
    | 'application/fsharp-script'
    | 'application/futuresplash'
    | 'application/hta'
    | 'application/internet-property-stream'
    | 'application/java-archive'
    | 'application/json'
    | 'application/liquidmotion'
    | 'application/mac-binhex40'
    | 'application/ms-vsi'
    | 'application/msaccess'
    | 'application/msaccess.addin'
    | 'application/msaccess.cab'
    | 'application/msaccess.ftemplate'
    | 'application/msaccess.runtime'
    | 'application/msaccess.webapplication'
    | 'application/msword'
    | 'application/octet-stream'
    | 'application/oda'
    | 'application/oleobject'
    | 'application/olescript'
    | 'application/onenote'
    | 'application/opensearchdescription+xml'
    | 'application/pdf'
    | 'application/pics-rules'
    | 'application/pkcs10'
    | 'application/pkcs7-mime'
    | 'application/pkcs7-signature'
    | 'application/pkix-crl'
    | 'application/postscript'
    | 'application/rat-file'
    | 'application/rtf'
    | 'application/sdp'
    | 'application/set-payment-initiation'
    | 'application/set-registration-initiation'
    | 'application/streamingmedia'
    | 'application/vnd.adobe.air-application-installer-package+zip'
    | 'application/vnd.fdf'
    | 'application/vnd.ms-excel'
    | 'application/vnd.ms-excel.addin.macroEnabled.12'
    | 'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
    | 'application/vnd.ms-excel.sheet.macroEnabled.12'
    | 'application/vnd.ms-excel.template.macroEnabled.12'
    | 'application/vnd.ms-mediapackage'
    | 'application/vnd.ms-office.calx'
    | 'application/vnd.ms-officetheme'
    | 'application/vnd.ms-pki.certstore'
    | 'application/vnd.ms-pki.pko'
    | 'application/vnd.ms-pki.seccat'
    | 'application/vnd.ms-pki.stl'
    | 'application/vnd.ms-powerpoint'
    | 'application/vnd.ms-powerpoint.addin.macroEnabled.12'
    | 'application/vnd.ms-powerpoint.presentation.macroEnabled.12'
    | 'application/vnd.ms-powerpoint.slide.macroEnabled.12'
    | 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'
    | 'application/vnd.ms-powerpoint.template.macroEnabled.12'
    | 'application/vnd.ms-project'
    | 'application/vnd.ms-visio.viewer'
    | 'application/vnd.ms-word.document.macroEnabled.12'
    | 'application/vnd.ms-word.template.macroEnabled.12'
    | 'application/vnd.ms-works'
    | 'application/vnd.ms-wpl'
    | 'application/vnd.ms-xpsdocument'
    | 'application/vnd.oasis.opendocument.presentation'
    | 'application/vnd.oasis.opendocument.text'
    | 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    | 'application/vnd.openxmlformats-officedocument.presentationml.slide'
    | 'application/vnd.openxmlformats-officedocument.presentationml.slideshow'
    | 'application/vnd.openxmlformats-officedocument.presentationml.template'
    | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    | 'application/vnd.openxmlformats-officedocument.spreadsheetml.template'
    | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    | 'application/vnd.openxmlformats-officedocument.wordprocessingml.template'
    | 'application/vnd.rn-realmedia'
    | 'application/vnd.rn-rn_music_package'
    | 'application/vnd.visio'
    | 'application/vnd.wap.wmlc'
    | 'application/vnd.wap.wmlscriptc'
    | 'application/vsix'
    | 'application/windows-library+xml'
    | 'application/windows-search-connector+xml'
    | 'application/winhlp'
    | 'application/wlmoviemaker'
    | 'application/x-7z-compressed'
    | 'application/x-bcpio'
    | 'application/x-bridge-url'
    | 'application/x-cdf'
    | 'application/x-compress'
    | 'application/x-compressed'
    | 'application/x-cpio'
    | 'application/x-csh'
    | 'application/x-director'
    | 'application/x-dvi'
    | 'application/x-gtar'
    | 'application/x-hdf'
    | 'application/x-internet-signup'
    | 'application/x-iphone'
    | 'application/x-itunes-ipa'
    | 'application/x-itunes-ipg'
    | 'application/x-itunes-ipsw'
    | 'application/x-itunes-ite'
    | 'application/x-itunes-itlp'
    | 'application/x-itunes-itms'
    | 'application/x-itunes-itpc'
    | 'application/x-java-applet'
    | 'application/x-java-jnlp-file'
    | 'application/x-javascript'
    | 'application/x-latex'
    | 'application/x-miva-compiled'
    | 'application/x-mmxp'
    | 'application/x-mpeg'
    | 'application/x-mpegURL'
    | 'application/x-ms-application'
    | 'application/x-ms-license'
    | 'application/x-ms-manifest'
    | 'application/x-ms-reader'
    | 'application/x-ms-vsto'
    | 'application/x-ms-wmd'
    | 'application/x-ms-xbap'
    | 'application/x-msaccess'
    | 'application/x-mscardfile'
    | 'application/x-msclip'
    | 'application/x-msdownload'
    | 'application/x-msmediaview'
    | 'application/x-msmetafile'
    | 'application/x-mspublisher'
    | 'application/x-msterminal'
    | 'application/x-mswrite'
    | 'application/x-netcdf'
    | 'application/x-oleobject'
    | 'application/x-perfmon'
    | 'application/x-pkcs12'
    | 'application/x-pkcs7-certificates'
    | 'application/x-pkcs7-certreqresp'
    | 'application/x-podcast'
    | 'application/x-quicktimeplayer'
    | 'application/x-safari-safariextz'
    | 'application/x-safari-webarchive'
    | 'application/x-sgimb'
    | 'application/x-sh'
    | 'application/x-shar'
    | 'application/x-shockwave-flash'
    | 'application/x-silverlight-app'
    | 'application/x-smaf'
    | 'application/x-stuffit'
    | 'application/x-sv4cpio'
    | 'application/x-sv4crc'
    | 'application/x-tar'
    | 'application/x-tcl'
    | 'application/x-tex'
    | 'application/x-texinfo'
    | 'application/x-troff'
    | 'application/x-troff-man'
    | 'application/x-troff-me'
    | 'application/x-troff-ms'
    | 'application/x-ustar'
    | 'application/x-wais-source'
    | 'application/x-wlpg-detect'
    | 'application/x-wlpg3-detect'
    | 'application/x-x509-ca-cert'
    | 'application/x-zip-compressed'
    | 'application/xaml+xml'
    | 'application/xhtml+xml'
    | 'application/xml'
    | 'application/zip'
    | 'audio/aac'
    | 'audio/ac3'
    | 'audio/aiff'
    | 'audio/audible'
    | 'audio/basic'
    | 'audio/m4a'
    | 'audio/m4b'
    | 'audio/m4p'
    | 'audio/mid'
    | 'audio/scpls'
    | 'audio/ogg'
    | 'audio/opus'
    | 'audio/vnd.audible.aax'
    | 'audio/vnd.dlna.adts'
    | 'audio/wav'
    | 'audio/x-aiff'
    | 'audio/x-caf'
    | 'audio/x-gsm'
    | 'audio/x-m4r'
    | 'audio/x-mpegurl'
    | 'audio/x-ms-wax'
    | 'audio/x-pn-realaudio'
    | 'audio/x-pn-realaudio-plugin'
    | 'audio/x-sd2'
    | 'audio/x-smd'
    | 'drawing/x-dwf'
    | 'application/x-gzip'
    | 'image/avif'
    | 'image/bmp'
    | 'image/cis-cod'
    | 'image/gif'
    | 'image/ief'
    | 'image/jpeg'
    | 'image/jpg'
    | 'image/pict'
    | 'image/pjpeg'
    | 'image/png'
    | 'image/tiff'
    | 'image/vnd.ms-photo'
    | 'image/vnd.rn-realflash'
    | 'image/vnd.wap.wbmp'
    | 'image/webp'
    | 'image/x-cmu-raster'
    | 'image/x-cmx'
    | 'image/x-icon'
    | 'image/x-jg'
    | 'image/x-macpaint'
    | 'image/x-portable-anymap'
    | 'image/x-portable-bitmap'
    | 'image/x-portable-graymap'
    | 'image/x-portable-pixmap'
    | 'image/x-quicktime'
    | 'image/x-rgb'
    | 'image/x-xbitmap'
    | 'image/x-xpixmap'
    | 'image/x-xwindowdump'
    | 'message/rfc822'
    | 'application/x-msmoney'
    | 'audio/mpeg'
    | 'application/x-msschedule'
    | 'text/scriptlet'
    | 'text/css'
    | 'text/csv'
    | 'text/dlm'
    | 'text/h323'
    | 'text/html'
    | 'text/iuls'
    | 'text/jscript'
    | 'text/plain'
    | 'text/richtext'
    | 'text/sgml'
    | 'text/tab-separated-values'
    | 'text/vbscript'
    | 'text/vnd.wap.wmlscript'
    | 'text/webviewhtml'
    | 'text/x-component'
    | 'text/x-hdml'
    | 'text/x-html-insertion'
    | 'text/x-ms-contact'
    | 'text/x-ms-group'
    | 'text/x-ms-iqy'
    | 'text/x-ms-odc'
    | 'text/x-ms-rqy'
    | 'text/x-setext'
    | 'text/x-vcard'
    | 'text/xml'
    | 'video/AV1'
    | 'video/vnd.dlna.mpeg-tts'
    | 'video/3gpp'
    | 'video/3gpp2'
    | 'video/quicktime'
    | 'video/mp4'
    | 'video/mpeg'
    | 'video/x-dv'
    | 'video/x-flv'
    | 'video/x-ivf'
    | 'video/x-la-asf'
    | 'video/x-m4v'
    | 'video/x-matroska'
    | 'video/x-ms-asf'
    | 'video/x-ms-wm'
    | 'video/x-ms-wmv'
    | 'video/x-ms-wvx'
    | 'video/x-msvideo'
    | 'video/x-sgi-movie'
    | 'video/webm'
    | 'audio/x-ms-wma'
    | 'text/vnd.wap.wml'
    | 'video/x-ms-wmp'
    | 'video/x-ms-wmx'
    | 'vnd.apple.mpegURL'
    | 'application/x-ms-wmz'
    | 'x-world/x-vrml';

export interface IMimeType {
    mimeTypeToFileExtension: (mimeType: MimeType) => string | null;
    fileExtensionToMimeType: (fileExtension: string) => MimeType | null;
    isMimeType: (object: unknown) => object is MimeType;
}

export function injectMimeType(container: IContainer = injectOrBuildContainer()): IMimeType {
    return container.get<IMimeType>(TYPES.IMimeType);
}

export function bindMimeType(
    value: IMimeType,
    container: IContainer = injectOrBuildContainer(),
): void {
    container.bind<IMimeType>(TYPES.IMimeType, value);
}

export function unbindMimeType(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IMimeType);
}
